<template>
  <transition @before-enter="beforeEnter" @enter="enter" @leave="leave" :css="false" appear>
    <section :class="this.name">
      <div class="bg"></div>
      <div class="content">
        <detail v-if="activeLayer == 'hunting1'">
          <h1 class="detail__title"><img :src="`${$staticUrl}img/detail/hunting/hunting1-title.png`" alt=""></h1>

          <div class="detail__tab">
            <button @click="handleClickTo(0)"
                    :class="['detail__tab-button', 'detail__tab-button--hunting1-1', hunting1TabIndex == 0 && 'detail__tab-button--active']">붉은 기사단 훈련소
            </button>
            <button @click="handleClickTo(1)"
                    :class="['detail__tab-button', 'detail__tab-button--hunting1-2', hunting1TabIndex == 1 && 'detail__tab-button--active']">말하는섬 필드
            </button>
            <button @click="handleClickTo(2)"
                    :class="['detail__tab-button', 'detail__tab-button--hunting1-3', hunting1TabIndex == 2 && 'detail__tab-button--active']">검은 전함
            </button>
            <button @click="handleClickTo(3)"
                    :class="['detail__tab-button', 'detail__tab-button--hunting1-4', hunting1TabIndex == 3 && 'detail__tab-button--active']">말하는 섬 전던
            </button>
            <button @click="handleClickTo(4)"
                    :class="['detail__tab-button', 'detail__tab-button--hunting1-5', hunting1TabIndex == 4 && 'detail__tab-button--active']">수련 던전
            </button>
            <button @click="handleClickTo(5)"
                    :class="['detail__tab-button', 'detail__tab-button--hunting1-6', hunting1TabIndex == 5 && 'detail__tab-button--active']">기사단 주화
            </button>
          </div>

          <slide ref="hunting1"
                 @transitionend="handleTransitionEnd"
                 @transitionstart="handleTransitionStart"
                 :slideList="layerData.hunting1.list"
                 :width="documentSize.width"
                 :height="layerData.hunting1.height"
                 :noPagination="true">
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/hunting/hunting1-con-1.png`" alt="" slot="slide0"/>`,
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/hunting/hunting1-con-2.png`" alt="" slot="slide1"/>`,
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/hunting/hunting1-con-3.png`" alt="" slot="slide2"/>`,
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/hunting/hunting1-con-4.png`" alt="" slot="slide3"/>`,
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/hunting/hunting1-con-5.png`" alt="" slot="slide4"/>`,
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/hunting/hunting1-con-6.png`" alt="" slot="slide5"/>`,
          </slide>
        </detail>

        <detail v-show="activeLayer == 'hunting2'">
          <h1 class="detail__title"><img :src="`${$staticUrl}img/detail/hunting/hunting2-title.png`" alt=""></h1>
          <p class="detail__sub-title"><img :src="`${$staticUrl}img/detail/hunting/hunting2-sub-title.png`" alt=""></p>

          <slide ref="hunting2"
                 @transitionend="handleTransitionEnd"
                 @transitionstart="handleTransitionStart"
                 :slideList="layerData.hunting2.list"
                 :width="documentSize.width"
                 :height="layerData.hunting2.height"
                 :noPagination="true">

            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/hunting/hunting2-con-1.png`" alt="" slot="slide0"/>`,
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/hunting/hunting2-con-2.png`" alt="" slot="slide1"/>`,
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/hunting/hunting2-con-3.png`" alt="" slot="slide2"/>`,
          </slide>

          <div class="slide-dot-area">
            <button :class="['slide-dot-area__button', layerData.hunting2.index == 0 && 'slide-dot-area__button--active']"
                    @click="handleClickTo(0)">1번 슬라이드
            </button>

            <button :class="['slide-dot-area__button', layerData.hunting2.index == 1 && 'slide-dot-area__button--active']"
                    @click="handleClickTo(1)">2번 슬라이드
            </button>

            <button :class="['slide-dot-area__button', layerData.hunting2.index == 2 && 'slide-dot-area__button--active']"
                    @click="handleClickTo(2)">3번 슬라이드
            </button>
          </div>
        </detail>

        <detail v-if="activeLayer == 'hunting3'">
          <h1 class="detail__title"><img :src="`${$staticUrl}img/detail/hunting/hunting3-title.png`" alt=""></h1>
          <p class="detail__sub-title"><img :src="`${$staticUrl}img/detail/hunting/hunting3-sub-title.png`" alt=""></p>

          <slide ref="hunting3"
                 @transitionend="handleTransitionEnd"
                 @transitionstart="handleTransitionStart"
                 :slideList="layerData.hunting3.list"
                 :width="documentSize.width"
                 :height="layerData.hunting3.height"
                 :noPagination="true">
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/hunting/hunting3-con-1.png`" alt="" slot="slide0"/>`,
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/hunting/hunting3-con-2.png`" alt="" slot="slide1"/>`,
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/hunting/hunting3-con-3.png`" alt="" slot="slide2"/>`,
          </slide>

          <div class="slide-dot-area">
            <button :class="['slide-dot-area__button', layerData.hunting3.index == 0 && 'slide-dot-area__button--active']"
                    @click="handleClickTo(0)">1번 슬라이드
            </button>

            <button :class="['slide-dot-area__button', layerData.hunting3.index == 1 && 'slide-dot-area__button--active']"
                    @click="handleClickTo(1)">2번 슬라이드
            </button>

            <button :class="['slide-dot-area__button', layerData.hunting3.index == 2 && 'slide-dot-area__button--active']"
                    @click="handleClickTo(2)">3번 슬라이드
            </button>
          </div>
        </detail>
      </div>
    </section>
  </transition>
</template>

<script>
  import BasePage from "./mixins/basePage.js";
  import YoutubePlayer from "promokit-youtubeplayer";

  export default {
    name: "hunting",
    mixins: [BasePage],
    data() {
      return {
        name: "hunting",
        contentData: [
         // {type: "bg", source: this.$staticUrl + "img/bg_3.jpg", objName: "bg"},
          {type:'bg', source:'https://vod.plaync.com/lineage/remaster0320/0320_remaster_bg3.mp4', objName:'bgmovie'},
          {type: "txt", source: this.$staticUrl + "img/txt_3_tit.png", objName: "obj_tit", x: 152, y: 347, delay: "-=0.3"},
          {type: "txt", source: this.$staticUrl + "img/txt_3_stit.png", objName: "obj_stit", x: 132, y: 380},
          {type: "txt", source: this.$staticUrl + "img/txt_3_txt.png", objName: "obj_txt", x: 159, y: 579},

          {type: "btn", source: this.$staticUrl + "img/btn_3_1.png", objName: "hunting1", x: 154, y: 690},
          {type: "btn", source: this.$staticUrl + "img/btn_3_2.png", objName: "hunting2", x: 374, y: 690},
          {type: "btn", source: this.$staticUrl + "img/btn_3_3.png", objName: "hunting3", x: 594, y: 690},
        ],
        layerData: {
          hunting1: {
            list: 6,
            index: 0,
            height: 668,
          },
          hunting2: {
            list: 3,
            index: 0,
            height: 591,
          },
          hunting3: {
            list: 3,
            index: 0,
            height: 591,
          },
        },
      };
    },
    computed: {
      hunting1TabIndex() {
        return this.layerData.hunting1.index;
      },

    },
    methods: {
      canvasSet() {
        this.baseCavasSet(this.contentData);
      },
      enter(el, done) {
        this.baseEnter();
        this.canvasSet();
        //this.canvas.start();
        this.baseEnterMotion(el, done, this.contentData);
        this.enterMotion.play();
      },
      leave(el, done) {
        if (this.enterMotion) this.enterMotion.pause();
        this.baseLeaveMotion(el, done);
      },
    },
    mounted() {
      // let videoHunting1 = new YoutubePlayer({
      //   el: "#hunting-video-1",
      //   videoId: "IfS6GcRxdv4",
      // });
      //
      // videoHunting1.on("play", () => {
      //   window.nowPlayingVideo = videoHunting1;
      // });
    },
  };
</script>